import { render, staticRenderFns } from "./Efficiencies.vue?vue&type=template&id=346e2cc4&scoped=true"
import script from "./Efficiencies.vue?vue&type=script&lang=js"
export * from "./Efficiencies.vue?vue&type=script&lang=js"
import style0 from "./Efficiencies.vue?vue&type=style&index=0&id=346e2cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346e2cc4",
  null
  
)

export default component.exports